<div class="cart">
    <div class="cart-main">
        <div><a class="link link_back" href="/">Continue Shopping</a></div>
        <table class="project">
            <thead class="project-hd">
                <tr class="project-hd-accentRow">
                    <th>Shopping Cart</th>
                    <th></th>
                    <th style="text-align: right;">Quantity</th>
                    <th style="text-align: right;">Price</th>
                    <th></th>
                </tr>
            </thead>
            {{#each cartGroups}}
                <tbody class="project-bd {{#if isCompanionGroup}}project-bd_companionGroup{{/if}}">
                    {{#each items}}
                        <tr id="cart-item-{{id}}" class="orderItem {{#if companionSourceId}}orderItem_isCompanion{{/if}} {{#if pending}}orderItem_isPending{{/if}} {{#unless isValid}}orderItem_isInvalid{{/unless}}"></tr>
                    {{/each}}
                </tbody>
            {{/each}}
            <tbody class="project-bd">
                {{#unless cart.canCheckout}}
                    <tr>
                        <td colspan="5">
                            <div class="messageBox messageBox_tight messageBox_warning">
                                <span class="lbl lbl_lg lbl_reversed">Invalid item(s) in cart. Item(s) need to be removed to checkout</span>
                            </div>
                        </td>
                    </tr>
                {{/unless}}
                <tr>
                    <td colspan="5" style="padding-top: 0;" id="fileUploadWarnings"></td>
                </tr>
            </tbody>
        </table>
        {{> savedForLater}}
    </div>
    <div class="cart-aside">
        <div class="cart-aside-inner">
            <div class="project-ft">
                <div class="project-ft-totals">
                    {{#if loggedIn}}
                        <div class="js--element-loyalyApply"></div>
                    {{/if}}
                    {{#if cart.canApplyPromotion}}
                        <div class="project-ft-totals-promo">
                            <form action="" class="spdcForm">
                                <div class="spdcForm-row spdcForm-row_inline{{#if requestProcessing}} requestIsProcessing{{/if}}">
                                    <div>
                                        <label class="spdcForm-lbl" for="promoCodeInput">Promo Code</label>
                                        <input class="spdcForm-inputText" id="js-promoCodeInput" type="text" {{#if cart.promotion.code}} disabled="disabled" value="{{cart.promotion.code}}"{{/if}} />
                                    </div>
                                    {{#if cart.promotion.code}}
                                        <input type="submit" class="spdcForm-btn js-promoInputRemove" value="Remove"/>
                                    {{else}}
                                        <input type="submit" class="spdcForm-btn spdcForm-btn_reverse js-promoInputSubmit" value="Apply"/>
                                    {{/if}}
                                </div>
                            </form>
                            {{#if cart.promotion.name}}
                                <div class="project-ft-totals-promo-message">
                                    <div class="lbl lbl_serif">You saved <span class="lbl lbl_lg lbl_tight">${{cart.promotion.displayAmount}}</span> with promotion:<br />
                                    <span class="lbl lbl_bold">{{cart.promotion.name}}</span></div>
                                </div>
                            {{else}}
                                <div id="js-promoErrorMsg" class="project-ft-totals-promo-message project-ft-totals-promo-message_invalid {{#unless promoErrors.code}}isHidden{{/unless}}">
                                    <div class="lbl lbl_reversed">{{promoErrors.code}}</div>
                                </div>
                            {{/if}}
                            {{#if cart.userDiscount}}
                                <div class="project-ft-totals-promo-message">
                                    <div class="lbl lbl_serif">You saved <span class="lbl lbl_lg lbl_tight">${{cart.userDiscount.displayAmount}}</span> with discount:<br />
                                    <span class="lbl lbl_bold">{{cart.userDiscount.name}}</span></div>
                                </div>
                            {{/if}}
                            {{#if cart.itemDiscountAmount}}
                                <div class="project-ft-totals-promo-message">
                                    <div class="lbl lbl_serif">You saved <span class="lbl lbl_lg lbl_tight">${{cart.displayItemDiscountAmount}}</span> in item discounts</div>
                                </div>
                            {{/if}}
                        </div>
                    {{/if}}
                    <ul class="project-ft-totals-tally">
                        <li>
                            <span>Subtotal:</span>
                            <span>
                                {{!-- TODO: Make a block helper (if_odd) for 'if truthy' check --}}
                                {{#if cart.displaySubtotalPrice}}${{cart.displaySubtotalPrice}}{{else}}$- -{{/if}}
                            </span>
                        </li>
                        {{#if cart.loyaltyDiscount}}
                            <li class="project-ft-totals-tally-promo">
                                <span>Print Points Discount:</span>
                                <span>- ${{cart.loyaltyDiscount.displayAmount}}</span>
                            </li>
                        {{/if}}
                        {{#if cart.canEstimateShipping}}
                            <li class="project-ft-totals-tally-shipping">
                                {{#if cart.shippingSummary.vendorName}}
                                    <div>
                                        <span><button class="linkBtn js-shippingEstimate"> {{cart.shippingSummary.vendorName}} </button> to {{cart.shippingSummary.postalCode}}</span>
                                    </div>
                                {{else}}
                                    <div>
                                        <a href="" class="js-shippingEstimate">Estimate Delivery:</a>
                                    </div>
                                {{/if}}
                                <span>
                                    {{#if cart.shippingSummary.price}}${{cart.shippingSummary.displayPrice}}{{else}}$- -{{/if}}
                                </span>
                            </li>
                        {{/if}}
                        {{#if cart.promotion.name}}
                            <li class="project-ft-totals-tally-promo">
                                <span>Promo Discount:</span>
                                <span>- ${{cart.promotion.displayAmount}}</span>
                            </li>
                        {{/if}}
                        <li>
                            <span>Sales Tax:</span>
                            <span>
                                {{#if cart.taxPrice}}${{cart.displayTaxPrice}}{{else}}$- -{{/if}}
                            </span>
                        </li>
                        {{#if cart.creditAccountsDiscountAmount}}
                            <li class="mix-">
                                <span>Applied Credits:</span>
                                <span>- ${{cart.displayCreditAccountsDiscountAmount}}</span>
                            </li>
                        {{/if}}
                        <li class="project-ft-totals-tally-total">
                            <span>Total:</span>
                            <span>
                                {{#if cart.totalPrice}}${{cart.displayTotalPrice}}{{else}}$- -{{/if}}
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="project-ft-actions">
                    {{#if cart.canCheckout}}
                        <a class="btn btn_cta js-checkoutBtn" href="/order/user-account?projectId={{cart.id}}">Checkout</a>
                    {{else}}
                        <button disabled="disabled" class="btn btn_cta">Checkout</button>
                    {{/if}}
                </div>
            </div>
        </div>
    </div>
</div>